import PointHttpClientService from "@/CommonVueCore/src/services/httpService/axios/pointHttpClientService.js";

export class AuthenticationServiceClient extends PointHttpClientService {
  constructor({ baseUri }) {
    super({
      baseUrl: baseUri,
    });
  }

  getComplexes() {
    return this.get({
      route: "/complex/get",
      headers: {
        "X-YPH-COMPLEX": "ALL",
      },
    });
  }
}
